<template>
  <div>
    <section class="base-header-sec base-header-laen laen">
      <div class="base-header__top-line laen"></div>
      <div class="container-fluid">
        <div class="base-header__container">
          <div class="d-flex justify-content-center align-items-center">
            <h1 class="base-header__title text-center py-2">Newsletter</h1>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <h3>{{ messagePrint }}</h3>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_NEWSLETTER_DEV,
      messagePrint: ""
    };
  },
  methods: {
    testCidQuery() {
      return this.$route.query.cid;
    },
    testUidQuery() {
      return this.$route.query.uid;
    },
    subscribeUser(cid) {
      var self = this;
      axios
        .get(
          `${self.baseApiUrl}prins/confirmSubscription/${cid}`
        )
        .then(res => {
          if (res.data.status === -1) {
            self.messagePrint = res.data.message;
          }
          if (res.data.status === 0) {
            self.messagePrint = res.data.message;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    unSubscribe(uid) {
      var self = this;
      axios.get(`${self.baseApiUrl}prins/cancelSubscription/${uid}`)
        .then(res => {
          if (res.data.status === 0) {
            self.messagePrint = res.data.message;
          }
          if (res.data.status === -1) {
            self.messagePrint = res.data.message;
          }
        })
        .catch(err => {
          console.log("Uuid nije dobar ", err)
        })
    }
  },
  mounted() {
    let cid = this.testCidQuery();
    let uid = this.testUidQuery();
    if (cid) {
      this.subscribeUser(cid);
    }
    if (uid) {
      this.unSubscribe(uid);
    }
  }
};
</script>
<style lang="css" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}
</style>